import { Box, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { FORMATTER } from "../../../services";
import { useEffect, useState } from "react";
import QtyField from "../../common/QtyField";

const AddonsSelectQtyItem = ({
  row,
  defaultAddonQty,
  setAddonSelectedQty,
  isSelected,
}) => {
  const [qty, setQty] = useState(defaultAddonQty);

  useEffect(() => {
    setAddonSelectedQty(row, qty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row, qty]);

  const renderLabel = (row) => {
    return (
      <>
        {row.option}&nbsp;({FORMATTER.formatCurrent(row.price_out)})
      </>
    );
  };

  const isRequired = row?.option_data?.required === true;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "left",
        }}
      >
        <FormControlLabel
          sx={{ padding: 0.5 }}
          control={
            <Checkbox
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
              color="secondary"
            />
          }
          onChange={() => setQty(qty === 0 ? 1 : 0)}
          checked={isSelected(row)}
          label={renderLabel(row)}
        />
        <QtyField
          value={qty}
          onChange={(qty) => setQty(qty)}
          allowNullValue={!isRequired}
        />
      </Box>
    </>
  );
};

const AddonsSelectQty = ({
  addon,
  addongroup,
  addonQty,
  setAddonSelectedQty,
  handleSelectionClick,
  isSelected,
}) => (
  <FormGroup>
    {(addon || []).map((row, idx) => (
      <AddonsSelectQtyItem
        key={"addonoption_" + idx}
        row={row}
        defaultAddonQty={addonQty[row.aoid] || 0}
        handleSelectionClick={handleSelectionClick}
        setAddonSelectedQty={setAddonSelectedQty}
        isSelected={isSelected}
      />
    ))}
  </FormGroup>
);

export default AddonsSelectQty;
